<template>
  <div>
    <div class="radios" :class="Object.assign(classList, {'flat': this.flat})">
      <div class="label-wrapper">
        <div class="label">{{label}}:</div>
          <div class="asterisk" v-if="required">
            *
          </div>
      </div>
      <slot></slot>
    </div>
    <input-footer :error="error" :helper-text="helperText"/>
  </div>
</template>

<script>
  import InputFooter from '../../../components/ui/inputs/InputFooter'
  import input from '../../../mixins/input'

  export default {
    props: {
      label: String,
      error: String,
      helperText: String,
      flat: {
        type: Boolean,
        default: false
      },
    },

    components: {InputFooter},
    mixins: [input]
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'

  .radios
    display: flex
    flex-direction: column
    align-items: left
    justify-content: flex-start
    &.flat
      flex-direction: row

    > .label-wrapper 
      align-items: center
      display: flex
      min-height: 45px
      padding-right: 20px

    > .label
      color: $color-text
      padding-right: 20px
      text-transform: capitalize

    &.is-invalid
      + .input-footer
        .validation-error
          color: $color-error
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/Radios.vue